<template>
  <FlexContainer class="home">
    <FlexItem :grow="true">
      <Content
        pattern="main-white"
        patternOpacity="20"
        background="primary"
        padding="large-vertical"
      >
        <CopyWithImage
          :src="require(`@/assets/images/thebabystuff-logo-rotated.png`)"
          padding="large"
        >
          <h1>
            Compare all the best deals from the UK's top retailers to make
            buying for your baby easier.
          </h1>
        </CopyWithImage>
      </Content>
      <Content>
        <FlexContainer>
          <FlexItem size="50%" padding="normal">
            <Card>
              <FlexContainer>
                <FlexItem padding="small-horizontal">
                  <PramSVG type="primary" width="64px" v-if="isMobile()" />
                  <h3>Prams</h3>
                  <p>
                    Compare the latest deals on Prams from the UK's leading
                    retailers
                  </p>
                  <ButtonRouterLink type="primary" :to="`/prams`">View All Deals</ButtonRouterLink>
                </FlexItem>
                <FlexItem size="40%" v-if="!isMobile()">
                  <PramSVG type="primary" height="100%" />
                </FlexItem>
              </FlexContainer>
            </Card>
          </FlexItem>
          <FlexItem size="50%" padding="normal">
            <Card>
              <FlexContainer>
                <FlexItem padding="small-horizontal">
                  <CarSeatSVG type="secondary" width="64px" v-if="isMobile()" />
                  <h3>Car Seats</h3>
                  <p>
                    Compare the latest deals on Car Seats from the UK's leading
                    retailers
                  </p>
                  <ButtonRouterLink type="secondary" :to="`/car-seats`">View All Deals</ButtonRouterLink>
                </FlexItem>
                <FlexItem size="40%" v-if="!isMobile()">
                  <CarSeatSVG type="secondary" height="100%" />
                </FlexItem>
              </FlexContainer>
            </Card>
          </FlexItem>
        </FlexContainer>
      </Content>
      <Content
        v-if="false"
        title="Featured Products"
        titleColour="primary-dark"
        background="white"
        padding="large-vertical"
        pattern="main-pink"
        patternOpacity="10"
      >
        <FlexContainer>
          <FlexItem width="25%">
            <PramSVG width="100" />
          </FlexItem>
          <FlexItem width="25%">
            <PramSVG width="100%" />
          </FlexItem>
          <FlexItem width="25%">
            <PramSVG height="75" />
          </FlexItem>
          <FlexItem width="25%">
            <PramSVG height="100%" />
          </FlexItem>
        </FlexContainer>
        <FlexContainer>
          <FlexItem>
            <ImageItem
              width="100%"
              :src="
                require(`@/assets/images/icons/tbs_icon_carseat_purple.svg`)
              "
            />
          </FlexItem>
          <FlexItem>
            <ImageItem
              height="100%"
              :src="
                require(`@/assets/images/icons/tbs_icon_carseat_purple.svg`)
              "
            />
          </FlexItem>
          <FlexItem>
            <ImageItem
              width="150"
              :src="
                require(`@/assets/images/icons/tbs_icon_carseat_purple.svg`)
              "
            />
          </FlexItem>
          <FlexItem>
            <ImageItem
              height="300"
              :src="
                require(`@/assets/images/icons/tbs_icon_carseat_purple.svg`)
              "
            />
          </FlexItem>
        </FlexContainer>
      </Content>
      <Content
        title="Price comparison across the leading pram, buggy & car seat retailers"
        titleColour="primary-dark"
        background="secondary-dark"
        padding="large-vertical"
        rainbows="dark"
      >
        <p>
          The Baby Stuff rounds up the best deals on Prams and Car seats from
          the UK's top retailers. We select the best products to take out the
          complexity in buying for your baby. Find deals on Prams and Car Seats
          from all the best brands including Joie, Silver Cross and Bugaboo and
          more.
        </p>
      </Content>
    </FlexItem>
  </FlexContainer>
</template>

<script>
import { analytics } from "@/firebase";

export default {
  metaInfo: {
    title: "Home"
  },
  methods: {
    isMobile() {
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        return true;
      } else {
        return false;
      }
    }
  },
  mounted() {
    analytics.logEvent("click", { type: "button" });
  }
};
</script>

<style lang="scss" scoped>
.home {
  width: 100%;
}

h1 {
  font-size: 3.2rem;
  font-weight: 700;
  letter-spacing: 0.125rem;
  line-height: 1.25;
  color: $white;
  text-align: left;
}
</style>
